import { PAWorkFlowModule } from "@/store/modules/paWorkFlow.module";
import { toaster } from "@/utilities/toaster";
import { assign, Machine } from "xstate";
const workflowsListingMachine = Machine({
    id: "workflowMachine",
    context: {
        searchData: {
            page: 1,
            pageSize: 10,
            sort: {
                field: "name",
                type: "none",
            },
            columnFilters: [],
        },
        workFlowId: "",
        ispageChanged: false,
    },
    initial: "idle",
    states: {
        idle: {
            on: {
                GETTING_WORKFLOWS: { target: "gettingWorkFlows" },
            },
        },
        gettingWorkFlows: {
            invoke: {
                id: "gettingWorkFlows",
                src: (context, event) => {
                    return PAWorkFlowModule.GetWorkFlows(context.searchData);
                },
                onDone: { target: "loadedWorkFlows" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedWorkFlows: {
            on: {
                GETTING_WORKFLOWS: { target: "gettingWorkFlows", actions: "assignSearchData" },
                VIEW_WORKFLOW: { target: "viewWorkFlow" },
                ARCHIVE_WORKFLOW: { target: "archivingWorkFlow", actions: "ispageChanged" },
                BULK_ARCHIVE_WORKFLOWS: { target: "bulkArchivingWorkFlows", actions: "ispageChanged" },
                DELETE_WORKFLOW: { target: "deleteWorkFlow", actions: "ispageChanged" },
            },
        },
        viewWorkFlow: {
            tags: "viewWorkFlow",
            invoke: {
                id: "viewWorkFlow",
                src: (cxt, evt) => {
                    return PAWorkFlowModule.GetWorkFlowByDetailById(evt.workFlowId);
                },
                onDone: { target: "viewingWorkFlow" },
                onError: { target: "loadedWorkFlows" },
            },
        },
        viewingWorkFlow: {
            tags: "viewWorkFlow",
            on: {
                CANCEL_WORKFLOW: { target: "loadedWorkFlows" },
            },
        },
        archivingWorkFlow: {
            invoke: {
                id: "archivingWorkFlow",
                src: (context, event) => {
                    return PAWorkFlowModule.ArchiveOrUnArchiveWorkFlow({ workFlowId: event.workFlowId, isArchive: event.isArchived });
                },
                onDone: { target: "gettingWorkFlows", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedWorkFlows" },
            },
        },
        bulkArchivingWorkFlows: {
            invoke: {
                id: "bulkArchivingWorkFlows",
                src: (context, event) => {
                    return PAWorkFlowModule.BulkArchiveOrUnArchiveWorkFlows({ workFlowIds: event.workFlowIds, isArchive: event.isArchived });
                },
                onDone: { target: "gettingWorkFlows", actions: ["showSuccessMessage", "setPage"] },
                onError: { target: "loadedWorkFlows" },
            },
        },
        deleteWorkFlow: {
            tags: "showdeleteWorkFlowUI",
            on: {
                DELETING_WORKFLOW: { target: "deletingWorkFlow" },
                CANCEL_WORKFLOW: { target: "loadedWorkFlows" },
            },
        },
        deletingWorkFlow: {
            tags: "showdeleteWorkFlowUI",
            invoke: {
                id: "archivingWorkFlow",
                src: (context, event) => {
                    return PAWorkFlowModule.DeleteWorkFlowById(event.workFlowId);
                },
                onDone: { target: "gettingWorkFlows", actions: ["showDeleteDone", "setPage"] },
                onError: { target: "loadedWorkFlows" },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignSearchData: assign({
            searchData: (context, event) => event.searchData,
        }),
        showDeleteDone: () => {
            toaster.ShowSuccess("A Workflow has been deleted successfully.");
        },
        setPage: assign({
            searchData: (context, event) => {
                if (context.ispageChanged) {
                    return {
                        ...context.searchData,
                        page: context.searchData.page - 1,
                    };
                }
                return context.searchData;
            },
        }),
        ispageChanged: assign({
            ispageChanged: (context, event) => event.ispageChanged,
        }),
    },
    services: {},
});
export default workflowsListingMachine;
